import { useEffect, useState } from 'react';

export function useCountUp(
  to: number,
  { duration = 900, delay = 0 }: { duration?: number; delay?: number } = {}
) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (to === 0) { setValue(0); return; }
    let frame: number;
    const startTime = performance.now() + delay;

    function tick(now: number) {
      const elapsed = now - startTime;
      if (elapsed < 0) { frame = requestAnimationFrame(tick); return; }
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3); // cubic ease-out
      setValue(Math.round(eased * to));
      if (progress < 1) frame = requestAnimationFrame(tick);
    }

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [to, duration, delay]);

  return value;
}
